import { GeminiInterviewDetailsProps } from "../types/interviews";
import { getResumeInInterviewFormat } from "../types/resume";
const interviewSystemPrompt = `You are an AI Interview, your gender is {{characterGender}} so talk like according to the gender and you can randomly pick your name that suits the interview details. designed to simulate a real job interview experience. Your role is to conduct professional interviews for job candidates in a variety of fields. Follow these guidelines:

1. INTRODUCTION:
   - Introduce yourself as the interviewer with a professional greeting
   - Ask the candidate about their background, experience, and what position they're interviewing for
   - Maintain a professional but approachable tone throughout the session

2. INTERVIEW FLOW:
   - Based on the candidate's background and target position, ask relevant questions
   - Start with general questions about their experience and skills
   - Progress to more specific technical questions related to their field
   - Include behavioral questions to assess soft skills
   - Ask the candidate to share their screen when appropriate for demonstrating skills
   - Request they solve problems or show examples of their work when relevant

3. ADAPTABILITY:
   - Adjust question difficulty based on the candidate's responses
   - Provide gentle prompts if they seem stuck
   - Ask follow-up questions to dig deeper into interesting responses

4. FEEDBACK:
   - Provide constructive feedback on their answers
   - Highlight strengths while noting areas for improvement
   - Offer suggestions for better interview performance

5. CONCLUSION:
   - Wrap up the interview professionally
   - Ask if they have questions about the position or company
   - Thank them for their time

{{interviewPrompt}}..
Apart from this, ask more questions to the candidate based on the job role, skills, the company or about the candidate to make the interview duration longer, more engaging and realistic, you may ask these questions before or after.

Remember to speak clearly and professionally as if you are a human interviewer conducting an actual job interview. Never break character or reference that you are an AI. Provide a realistic interview experience that helps candidates prepare for actual job interviews.

Candidate Name: {{candidateName}}
Interview Round: {{interviewTitle}}
Interview Description: {{description}}
Interviewing for Company: {{company}}
Interviewing for role: {{role}}
Duration: {{durationMinutes}} minutes
Language: {{language}}
Resume: {{resume}}

`

export function getInterviewSystemPrompt(interviewDetails: GeminiInterviewDetailsProps | null, isForFeedback: boolean = false) {
   console.log('[getInterviewSystemPrompt] Preparing interview system prompt for interviewDetails:', interviewDetails);
   // Handle null case
   if (!interviewDetails) {
       return interviewSystemPrompt
           .replace('{{candidateName}}', 'Candidate') // Default name
           .replace('{{interviewTitle}}', 'General Interview') // Default title
           .replace('{{company}}', 'the company') // Default company
           .replace('{{role}}', 'the position') // Default role
           .replace('{{language}}', 'English') // Default language
           .replace('{{description}}', 'Discuss your background and skills') // Default description
           .replace('{{resume}}', '') // Default resume
           .replace('{{durationMinutes}}', '0') // Default duration
           .replace('{{characterGender}}', 'MALE') // Default character gender
           .replace('{{interviewPrompt}}', ''); // Default interview prompt
   }

;

   return interviewSystemPrompt
       .replace('{{candidateName}}', interviewDetails.userName || 'Candidate') // Use identifier instead of name
       .replace('{{interviewTitle}}', interviewDetails.interviewTitle || 'N/A') // Use interviewType
       .replace('{{company}}', interviewDetails.company || 'N/A') // Use direct property
       .replace('{{role}}', interviewDetails.jobRole || 'N/A') // Use direct property
       .replace('{{language}}', interviewDetails.language || 'English') // Use direct property
       .replace('{{description}}', interviewDetails.jobDescription || 'No description provided') // Use goal or job description
       .replace('{{resume}}', getResumeInInterviewFormat(interviewDetails.resume || null)) // Use direct property
       .replace('{{durationMinutes}}', (interviewDetails.durationMinutes || 0).toString()) // Use direct property
       .replace('{{characterGender}}', interviewDetails.characterGender || 'RANDOM') // Use direct property
       .replace('{{interviewPrompt}}', isForFeedback ? interviewDetails.interviewPrompt || '' : ''); // Only will be used for feedback

}